const KEY = 'SF_LEAD_ID_COOKIE';

const COOKIE_EXPIRATION_MINS = 20;

const ONE_MINUTE_TO_SECONDS = 60;

const ONE_SECOND_TO_MILISECONDS = 1000;

export const createCookieExpirationDate = (minutes: number) => {
  const date = new Date();

  return date.setTime(
    date.getTime() + minutes * ONE_MINUTE_TO_SECONDS * ONE_SECOND_TO_MILISECONDS
  );
};

export const getLeadIdFromCookies = async () => {
  const cookie = await cookieStore.get(KEY);

  return cookie && cookie.value ? cookie.value : undefined;
};

export const setLeadIdToCookies = async (value: string) => {
  await cookieStore.set({
    name: KEY,
    value,
    expires: createCookieExpirationDate(COOKIE_EXPIRATION_MINS),
  });
};
